// we don't use export {...} from '...'; syntax
// because we need to import scss before and after
// components import

import './../styles/before-components.scss';

import Bar, { BarVertical, BarItem, BarBreak } from './Bar';
import Button, {
  ButtonLayout,
  ButtonGroup,
  ButtonPrimary,
  ButtonSecondary,
  ButtonTertiary,
  ButtonLink,
  ButtonToggle,
} from './Button/';
import Card, { CardHeader, CardContent, CardFooter } from './Card';
import Dialog, { DialogHeader, DialogBody, DialogFooter } from './Dialog';
import Dropdown, { DropdownItem } from './Dropdown';
import {
  Input,
  Textarea,
  Addon,
  Message,
  ErrorMessage,
  HelpMessage,
  Checkbox,
  Radio,
  RadioCheckGroup,
  Select,
  FormGrid,
} from './Forms';
import Grid, { Container, TextContainer, GridCol } from './Grid';
import Icon from './Icon';
import Image from './Image';
import List, { ListItem } from './List';
import Modal from './Modal';
import Table from './Table';
import { Tabs, TabPanel, Tab, TabLink } from './Tabs';
import Tooltip from './Tooltip';
import Header from './Header';
import Footer from './Footer';
import MainNav from './MainNav';
import Section from './Section';
import Slider, { SliderPagination } from './Slider';
import Banner from './Banner';
import Skeleton from './Skeleton';

import './../styles/after-components.scss';

// eslint-disable-next-line import/first
import 'aos/dist/aos.css';

require.context('./../assets/icons', false, /\.svg$/);

export { Bar, BarVertical, BarItem, BarBreak };
export {
  Button,
  ButtonLayout,
  ButtonGroup,
  ButtonPrimary,
  ButtonSecondary,
  ButtonTertiary,
  ButtonLink,
  ButtonToggle,
};
export { Card, CardHeader, CardContent, CardFooter };
export { Dialog, DialogHeader, DialogBody, DialogFooter };
export { Dropdown, DropdownItem };
export {
  Input,
  Textarea,
  Addon,
  Message,
  ErrorMessage,
  HelpMessage,
  Checkbox,
  Radio,
  RadioCheckGroup,
  Select,
  FormGrid,
};
export { Grid, Container, GridCol, TextContainer };
export { Icon };
export { Image };
export { List, ListItem };
export { Modal };
export { Table };
export { Tabs, TabPanel, Tab, TabLink };
export { Tooltip };
export { Header };
export { Footer };
export { MainNav };
export { Section };
export { Slider, SliderPagination };
export { Banner };
export { Skeleton };



// WEBPACK FOOTER //
// ./src/components/index.js